<template>
  <v-container fluid class="pa-0">    
    <v-container class="d-print-none">
      <v-alert
          v-if="!consent.approved"
          type="warning"
          class="rounded-lg"
          border="left"
      >
        {{ $t('labels.consent.notApproved') }} ({{ consent.lastUpdated | moment("DD MMM YYYY - HH:mm") }})
      </v-alert>
      <v-alert
          v-if="consent.approved"
          type="success"
          class="rounded-lg"
          border="left"
      >
        {{ $t('labels.consent.approved') }} ({{ consent.lastUpdated | moment("DD MMM YYYY - HH:mm") }})
      </v-alert>
    </v-container>
    
    <v-container>
      <div v-if="isLoading" class="d-flex justify-center my-3">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </div>
      <div v-if="!isLoading" v-html="page">
      </div>
    </v-container>
    <v-container>
      <div class="d-flex justify-center align-center">
        <v-btn
            v-on:click.prevent="handleConsent(false)"
            class="ma-1 d-print-none rounded-lg"
            depressed
            outlined
            color="error"
            :disabled="isLoading || !consent.approved"
        >
          {{ $t('buttons.deny')}}
        </v-btn>
        <v-btn
            v-on:click.prevent="handleConsent(true)"
            class="ma-1 d-print-none rounded-lg"
            depressed
            color="primary"
            :disabled="isLoading || consent.approved"
        >
          {{ $t('buttons.accept')}}
        </v-btn>
        <v-btn
            v-if="consent.approved"
            @click.prevent="navigate('/')"
            class="ma-1 d-print-none rounded-lg"
            depressed
            outlined
            color="primary"
            :disabled="isLoading"
        >
          {{ $t('buttons.home')}}
        </v-btn>
      </div>
      <v-btn
          class="d-print-none"
          color="primary"
          fab
          dark
          bottom
          right
          fixed
          @click.prevent="print()"
          :disabled="isLoading"
      >
        <v-icon>far fa-print</v-icon>
      </v-btn>

      <v-expansion-panels accordion flat multiple class="rounded-lg mt-5 d-print-none" v-model="historyAccordion">
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t('expansionPanel.header.consentHistory') }} -
            <span class="warning--text mx-1" v-if="!consent.approved"> {{ $t('labels.consent.notApproved') }} ({{ consent.lastUpdated | moment("DD MMM YYYY - HH:mm") }})</span>
            <span class="success--text mx-1" v-if="consent.approved"> {{ $t('labels.consent.approved') }} ({{ consent.lastUpdated | moment("DD MMM YYYY - HH:mm") }})</span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-list-item
                v-for="(consent,i) in consentHistory"
                :key="i"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('labels.consent.'+consent.approved) }} ({{ consent.lastUpdated | moment("DD MMM YYYY - HH:mm") }})
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </v-container>
</template>

<script>
import i18n from "@/services/i18n";
import api from "@/api/api";

export default {
  i18n: i18n,
  name: "m2h-consent",
  props: [],
  components: {
  },
  data() {
    return {
      isLoading: true,
      historyAccordion: [],
      consent: {},
      consentHistory: [],
      page: '',
      pageInstanceId: null
    }
  },
  mounted() {
    this.fetchConsentMarkdown()
    this.fetchConsent()

    this.$root.$on('language-changed', () => {
      this.fetchConsentMarkdown()
    })
  },

  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    },
  },

  methods: {
    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
    
    fetchConsentMarkdown() {
      this.isLoading = true
      const that = this
      api.consent.getPage(that.$i18n.locale)
          .then((res) => {
            that.page = res.data.pageMarkdown
            that.pageInstanceId = res.data.instanceId
            that.isLoading = false
          })
    },
    fetchConsent() {
      const that = this
      api.consent.get()
          .then((res) => {
            that.consent = res.data
            that.fetchConsentHistory(res.data.id);
          }) 
    },
    fetchConsentHistory(consentId) {
      const that = this
      api.consent.getConsentHistory(consentId)
          .then((res) => {
            that.consentHistory = res.data
          })
    },
    print(){
      window.print()
    },

    async handleConsent(approved){
      let that = this
      let data = {
        approved: approved,
        pageInstanceId: that.pageInstanceId
      }

      await api.consent.handleConsent(data)
          .then((res) => {
            if (res.data && res.data.redirectUrl) {
              window.location.href = res.data.redirectUrl
            } else {
              that.fetchConsent()
            }
          })
      
      if (!approved){
        await this.logout()
      }
    },

    async logout() {
      await api.account.logout()
          .then(() => {
            window.location.href = "/"
          })
    },
  },
}

</script>

<style scoped>
p {
  font-size: 1.3rem !important;
}

@media print {
  .noprint {
    visibility: hidden;
  }
}
</style>
